import { map } from 'lodash/fp';

import { CheckoutField, PORTAL_CONTAINER_ID } from '@mews-distributor/common';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews/text-keys';
import { DropdownItem, Select } from '@optimus-web/core';

const renderItems = map(({ code, name }) => <DropdownItem key={code} value={code} label={name} />);

export const NationalitySelect = ({ countries, ...other }: $TSFixMe) => (
    <Select
        {...other}
        label={<LocalizedText textKey={TextKey.Nationality} />}
        emptyMessage={<LocalizedText textKey={TextKey.NoDataAvailable} />}
        virtualized
        defaultItemHeight={48}
        portalContainerId={PORTAL_CONTAINER_ID}
        name={CheckoutField.NationalityCode}
    >
        {renderItems(countries)}
    </Select>
);
